// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"864e84d6","239":"be0d2136","455":"aee11584","885":"6e876a69"}[chunkId] + ".chunk.js";
};